<template>
    <v-dialog
            scrollable
            v-model="visible"
            max-width="900px"
            :fullscreen="fullscreen"
            :persistent="true"
    >
        <v-card>
            <v-toolbar flat dense>
                <v-toolbar-title class="subheading">{{ '认领' }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="fullscreen=!fullscreen">
                    <v-icon>fullscreen</v-icon>
                </v-btn>
            </v-toolbar>

            <v-divider style="max-height: 1px"/>
            <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

            <v-card-text>
                <v-form v-model="formValid" ref="formRef" lazy-validation>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs12 sm4 lg4>
                                <div class="x-text-field">
                                    <label>来款ID</label>
                                    <div>{{item.pznm}}</div>
                                </div>
                            </v-flex>

                            <!--<v-flex xs12 sm4 lg4>
                                <div class="x-text-field">
                                    <label>分录编号</label>
                                    <div>{{item.flbh}}</div>
                                </div>
                            </v-flex>
                            <v-flex xs12 sm4>
                                <div class="x-text-field">
                                    <label>科目编号</label>
                                    <div>{{item.kmbh}}</div>
                                </div>
                            </v-flex>

                            <v-flex xs12 sm4>
                                <div class="x-text-field">
                                    <label>部门编号</label>
                                    <div>{{item.bmbh}}</div>
                                </div>
                            </v-flex>
                            <v-flex xs12 sm4>
                                <div class="x-text-field">
                                    <label>项目编号</label>
                                    <div>{{item.xmbh}}</div>
                                </div>
                            </v-flex>
                            <v-flex xs12 sm4>
                                <div class="x-text-field">
                                    <label>对冲号</label>
                                    <div>{{item.dch}}</div>
                                </div>
                            </v-flex>-->

                            <v-flex xs12 sm8>
                                <div class="x-text-field">
                                    <label>摘要</label>
                                    <div>{{item.zy}}</div>
                                </div>
                            </v-flex>

                          <v-flex xs12 sm4>
                            <div class="x-text-field">
                              <label>金额</label>
                              <div>{{item.je}}</div>
                            </div>
                          </v-flex>

                          <v-flex xs12 sm8>
                            <div class="x-text-field">
                              <label>汇款单位</label>
                              <div>{{item.dfdw}}</div>
                            </div>
                          </v-flex>

                          <v-flex xs12 sm4>
                            <div class="x-text-field">
                              <label>来款日期</label>
                              <div>{{item.pzrq}}</div>
                            </div>
                          </v-flex>

                          <v-flex xs12 sm4>
                            <div class="x-text-field">
                              <label>资金性质</label>
                              <div>{{item.lkbz}}</div>
                            </div>
                          </v-flex>

                            <v-flex xs12 sm4>
                                <div class="x-text-field">
                                    <label>登记人</label>
                                    <div>{{item.zrr}}</div>
                                </div>
                            </v-flex>



                            <!--
                            <v-flex xs12 sm4>
                                <div class="x-text-field">
                                    <label>凭证编号</label>
                                    <div>{{item.pzbh}}</div>
                                </div>
                            </v-flex>-->




                           <!--
                            <v-flex xs12>
                                <v-autocomplete
                                        label="项目名称"
                                        item-text="name"
                                        item-value="dbid"
                                        :items="projectItems"
                                        v-model="form.projId"
                                        hide-details
                                        clearable
                                        :menu-props="{maxHeight:600}"
                                />
                            </v-flex>-->
                        </v-layout>
                    </v-container>
                    <v-card-actions>
                        <v-spacer/>
                        <v-btn color="blue darken-1" flat @click.native="visible = false">关闭</v-btn>
                        <!--根据中医大需求，暂时屏蔽这段代码<v-btn color="primary" @click.native="onSave(form.projId)" :disabled="item.rkbz=='01'">认领</v-btn>-->
                    </v-card-actions>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    import mixin from '@/mixin'
    const baseUri = '/api/proj/incoclaim';
    const projUri = '/api/proj/project';
    export default {
        mixins: [mixin.viewClaim(baseUri)],
        data() {
            return {
                formValid: false,
                item: {},

                form: {
                    "pznm": "",
                    "flbh": "",
                    "zy": "",
                    "dfdw": "",
                    "je": "",
                    "lxbh": "",
                    "xmbh": "",
                    "bmbh": "",
                    "kmbh": "",
                    "dch": "",
                    "zrr": "",
                    "pzbh": "",
                    "pzrq": "",
                    "zdr": "",
                    "projId": "",
                    "rkrq": "",
                    "rkbz": "",
                    "statusId": "",
                    "color": "",
                    "leaderName": "",
                    "claimName": ""
                },
                projectItems: [],
                defaultProjId:"",
                properties: {
                    "01": '银行来款',
                    "02": '科研来款',
                    "03": '其它来款'
                },
                flagMaps: {
                    "0": '未认领',
                    "1": '已认领'
                }
            }
        },
        created() {
            // 加载审核状态
            this.axios.all([
                this.axios.get(projUri+'/by/request/user')
            ]).then(
                this.axios.spread(
                    (rspProj) => {
                    this.projectItems = rspProj.data.items
        }
        )
        );
            this.form.projId = this.defaultProjId
        },
        watch: {

        },

        methods: {
           remote(item, queryText, itemText) {
                // 用于远下拉框的过滤，所以所有选都是显示在下拉框中
                return true;
            },
            // 保存响应函数
            onSave(projId) {
                const vm = this;
                this.loading = true;
               // const param = window.xutil.param("projId", projId);
            //    const param = window.xutil.param("projId", projId);
                const params = Object.assign(
                    window.xutil.param("projId", projId),
                    window.xutil.param("money",vm.item.je.toString())
                );
                this.axios.put(`${baseUri}/${vm.item.pznm}`+`?flbh=${vm.item.flbh}`, params)
                    .then(rsp => {
                    vm.$emit('ok', rsp.data);
                    vm.$emit('input', false);
                    vm.loading = false;
                    vm.visible = false;
            });
            }
        }
    }
</script>